const reasonCancellationOptions = [
  { id: 1, title: 'Vous avez trouvé moins cher' },
  {
    id: 2,
    title: 'Votre date de rdv ne vous convient plus',
  },
  {
    id: 3,
    title: "L'emplacement du réparateur ne vous convient plus",
  },
  { id: 4, title: 'Autre' },
];

export default reasonCancellationOptions;
